import { render, staticRenderFns } from "./UploadFileV2.vue?vue&type=template&id=af8fb4f6&"
import script from "./UploadFileV2.vue?vue&type=script&lang=js&"
export * from "./UploadFileV2.vue?vue&type=script&lang=js&"
import style0 from "./UploadFileV2.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports